import { createSlice } from '@reduxjs/toolkit'

import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const initialState = {}
const voting = createSlice({
  name: 'fursuit-voting',
  initialState,
  reducers: {
    selectFursuit (state, action) {
      const { payload } = action
      return {
        ...state,
        ...payload
      }
    },
    receiveFursuitsVotingData (state, _action) {
      return {
        ...state
      }
    }
  }
})

const persistConfig = {
  key: 'fursuit-voting',
  storage
}

export const { selectFursuit, receiveVotingData } = voting.actions
export const FursuitVotingReducer = persistReducer(persistConfig, voting.reducer)
